import { applyProviderCptAccessGuard } from './providerCptAccessGuard';
import { evaluateCptRules } from './rules';
import { scrubberResultsNeedUserReview } from './scrubberReview';
import type { EncounterScrubberInput, EncounterScrubberResult } from './types';

export type {
  EncounterScrubberInput,
  EncounterScrubberResult,
  MetadataValidationError,
  MdmLevel,
  PatientStatus,
  PayerPlanType,
  ScrubberAction,
  ScrubberSeverity,
} from './types';

export {
  calculate90840Units,
  expectedEmCodeByPatientStatusAndMdm,
  getExpectedEmCode,
  getExpectedPsychotherapyCodeByDuration,
  is96127Eligible,
  isInteractiveComplexitySupportedPrimaryPresent,
} from './helpers';

export {
  metadataErrorsBlockSave,
  validateEncounterScrubberMetadata,
} from './metadataValidation';

export { applyProviderCptAccessGuard } from './providerCptAccessGuard';

export {
  CRISIS_90839_MAX_MINUTES,
  CRISIS_90839_MIN_MINUTES,
  CRISIS_90840_FIRST_UNIT_MIN_MINUTES,
  DIAGNOSTIC_90791_MAX_MINUTES,
  DIAGNOSTIC_90791_MIN_MINUTES,
  DIAGNOSTIC_90792_DURATION_WARNING_TOLERANCE_MINUTES,
  DIAGNOSTIC_90792_STANDARD_MINUTES,
  FAMILY_THERAPY_MIN_MINUTES,
  GROUP_THERAPY_90853_MAX_MINUTES,
  GROUP_THERAPY_90853_MIN_MINUTES,
  INTERACTIVE_COMPLEXITY_SUPPORTED_PRIMARY_CODES,
  PSYCHOTHERAPY_90832_MAX_MINUTES,
  PSYCHOTHERAPY_90832_MIN_MINUTES,
  PSYCHOTHERAPY_90834_MAX_MINUTES,
  PSYCHOTHERAPY_90834_MIN_MINUTES,
  PSYCHOTHERAPY_90837_MIN_MINUTES,
  PSYCHOTHERAPY_ADD_ON_90833_MIN_MINUTES,
  PSYCHOTHERAPY_MIN_BILLABLE_MINUTES,
} from './constants';

/**
 * Evaluate selected CPT codes against encounter scrubber rules.
 * Provider CPT access is enforced globally after rule evaluation.
 */
export function scrubEncounterCptCodes(input: EncounterScrubberInput): EncounterScrubberResult[] {
  const raw = evaluateCptRules(input);
  return applyProviderCptAccessGuard(raw, input.providerAllowedCptCodes);
}

export function scrubberResultsBlockSave(results: EncounterScrubberResult[]): boolean {
  return results.some((r) => r.blocksSave === true || r.severity === 'error');
}

export { scrubberResultRowKey, scrubberResultsNeedUserReview } from './scrubberReview';
export type { ScrubberSuggestionDecision } from './scrubberReview';
export {
  applyAcceptedScrubberResult,
  applyAcceptedScrubberResults,
  buildEncounterScrubberReview,
} from './applyScrubberDecisions';

export function scrubberResultsHaveWarnings(results: EncounterScrubberResult[]): boolean {
  return scrubberResultsNeedUserReview(results).length > 0;
}
